import { InputDate, InputPhone } from '@fozito/common-ui';
import { Form, Input } from 'antd';
import InputEmail from 'modules/POS/Cashier/components/InputEmail';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { ICustomerFormValues } from './type';

type IFormCustomerProps = {
  value?: ICustomerFormValues;
};
const FormCustomer: React.FC<IFormCustomerProps> = ({ value }) => {
  const form = Form.useFormInstance();
  useEffect(() => {
    form.setFieldsValue(value);
  }, [value]);


  return (
    <FormCustomerStyled className='FormAddCustomerStyled'>
      <Form.Item name='name' label={'Full name'} rules={[{ required: true, message: 'Please input your name!' }]}>
        <Input />
      </Form.Item>
      <Form.Item name='phone' label={<>Phone<span className='required'>(*)</span></>} rules={[{ required: true, message: 'Please input your phone!' }]}>
        <InputPhone />
      </Form.Item>
      <Form.Item name='birthday' label={'DOB'}>
        <InputDate format='MM-DD' placeholder='MM-DD' />
      </Form.Item>
      <InputEmail
        name={'email'} label="Email" rules={[{ type: 'email' }]}
      />
    </FormCustomerStyled>
  );
};

export default FormCustomer;
type FormCustomerStyledProps = {}
const FormCustomerStyled = styled.div<FormCustomerStyledProps>`
  .required {
    color: var(--primary-primary-active, #FF8890);
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`;
